import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export interface PlaybackDurationStats {
  today: number // 秒數
  yesterday: number
}

export interface PlaybackDurationDailyRecord {
  date: string // YYYY-MM-DD
  duration_seconds: number
}

export function usePlaybackDurationStats(broadcastDeviceId?: number) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<PlaybackDurationStats>>(
    token && broadcastDeviceId
      ? `/api/broadcast-devices/${broadcastDeviceId}/playback-duration/stats`
      : null,
    undefined,
    token ?? '',
  )

  return {
    stats: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}

export interface UsePlaybackDurationRecordsParams {
  broadcastDeviceId?: number
  startDate?: string // YYYY-MM-DD
  endDate?: string
}

export function usePlaybackDurationRecords({
  broadcastDeviceId,
  startDate,
  endDate,
}: UsePlaybackDurationRecordsParams = {}) {
  const { token } = useAuth()

  const queryParams = new URLSearchParams()
  if (startDate) queryParams.append('startDate', startDate)
  if (endDate) queryParams.append('endDate', endDate)

  const shouldFetch = token && broadcastDeviceId
  const qs = queryParams.toString()

  const { data, error, mutate, isLoading } = useGet<
    ApiResponse<{ records: PlaybackDurationDailyRecord[] }>
  >(
    shouldFetch
      ? `/api/broadcast-devices/${broadcastDeviceId}/playback-duration/daily${qs ? `?${qs}` : ''}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    records: data?.data?.records || [],
    isLoading,
    isError: error,
    mutate,
  }
}
